export default {
    basic: "/api/v1",
    auth: "auth",
    admin: {
        basic: "admin",
        setting: "setting",
        users: "users",
        appusers: "mobile_users",
        delappusers: "del_mobile_users",
    },
    user: {
        ev: {
            basic: "ev",
            charger: "charger",
            schedule: "schedule",
            promotion: "promotion",
            location: "location",
            transactions: "transactions",
            report: "report",
        },
        advertising: {
            basic: "advertising",
            playlist: "playlist",
            mobileAdvService: "mobile_adv",
            document: "document",
        },
        my: "my"
    }

}